import { JOIN_GROUP_STUDY_PARAM } from 'constants/general';
import useSearchParams from './useSearchParams';

const useJoinSearchParam = () => {
  return useSearchParams(JOIN_GROUP_STUDY_PARAM);
};

export default useJoinSearchParam;
